import { semanticColors } from "~/common/colors/colors";

export const boldColors = [
    semanticColors.colorCoding.blueGrey.background.bold,
    semanticColors.colorCoding.blue.background.bold,
    semanticColors.colorCoding.teal.background.bold,
    semanticColors.colorCoding.green.background.bold,
    semanticColors.colorCoding.lime.background.bold,
    semanticColors.colorCoding.amber.background.bold,
    semanticColors.colorCoding.orange.background.bold,
    semanticColors.colorCoding.red.background.bold,
    semanticColors.colorCoding.pink.background.bold,
    semanticColors.colorCoding.purple.background.bold,
];

export const mediumColors = [
    semanticColors.colorCoding.blueGrey.background.medium,
    semanticColors.colorCoding.blue.background.medium,
    semanticColors.colorCoding.teal.background.medium,
    semanticColors.colorCoding.green.background.medium,
    semanticColors.colorCoding.lime.background.medium,
    semanticColors.colorCoding.amber.background.medium,
    semanticColors.colorCoding.orange.background.medium,
    semanticColors.colorCoding.red.background.medium,
    semanticColors.colorCoding.pink.background.medium,
    semanticColors.colorCoding.purple.background.medium,
];

export const lightColors = [
    semanticColors.colorCoding.blueGrey.background.light,
    semanticColors.colorCoding.blue.background.light,
    semanticColors.colorCoding.teal.background.light,
    semanticColors.colorCoding.green.background.light,
    semanticColors.colorCoding.lime.background.light,
    semanticColors.colorCoding.amber.background.light,
    semanticColors.colorCoding.orange.background.light,
    semanticColors.colorCoding.red.background.light,
    semanticColors.colorCoding.pink.background.light,
    semanticColors.colorCoding.purple.background.light,
];

export const thinColors = [
    semanticColors.colorCoding.blueGrey.background.thin,
    semanticColors.colorCoding.blue.background.thin,
    semanticColors.colorCoding.teal.background.thin,
    semanticColors.colorCoding.green.background.thin,
    semanticColors.colorCoding.lime.background.thin,
    semanticColors.colorCoding.amber.background.thin,
    semanticColors.colorCoding.orange.background.thin,
    semanticColors.colorCoding.red.background.thin,
    semanticColors.colorCoding.pink.background.thin,
    semanticColors.colorCoding.purple.background.thin,
];

export const colorOfContentMap = {
    [semanticColors.colorCoding.blueGrey.background.bold]: semanticColors.colorCoding.blueGrey.text.onBold,
    [semanticColors.colorCoding.blueGrey.background.medium]: semanticColors.colorCoding.blueGrey.text.onMedium,
    [semanticColors.colorCoding.blueGrey.background.light]: semanticColors.colorCoding.blueGrey.text.onLight,
    [semanticColors.colorCoding.blueGrey.background.thin]: semanticColors.colorCoding.blueGrey.text.onThin,

    [semanticColors.colorCoding.blue.background.bold]: semanticColors.colorCoding.blue.text.onBold,
    [semanticColors.colorCoding.blue.background.medium]: semanticColors.colorCoding.blue.text.onMedium,
    [semanticColors.colorCoding.blue.background.light]: semanticColors.colorCoding.blue.text.onLight,
    [semanticColors.colorCoding.blue.background.thin]: semanticColors.colorCoding.blue.text.onThin,

    [semanticColors.colorCoding.teal.background.bold]: semanticColors.colorCoding.teal.text.onBold,
    [semanticColors.colorCoding.teal.background.medium]: semanticColors.colorCoding.teal.text.onMedium,
    [semanticColors.colorCoding.teal.background.light]: semanticColors.colorCoding.teal.text.onLight,
    [semanticColors.colorCoding.teal.background.thin]: semanticColors.colorCoding.teal.text.onThin,

    [semanticColors.colorCoding.green.background.bold]: semanticColors.colorCoding.green.text.onBold,
    [semanticColors.colorCoding.green.background.medium]: semanticColors.colorCoding.green.text.onMedium,
    [semanticColors.colorCoding.green.background.light]: semanticColors.colorCoding.green.text.onLight,
    [semanticColors.colorCoding.green.background.thin]: semanticColors.colorCoding.green.text.onThin,

    [semanticColors.colorCoding.lime.background.bold]: semanticColors.colorCoding.lime.text.onBold,
    [semanticColors.colorCoding.lime.background.medium]: semanticColors.colorCoding.lime.text.onMedium,
    [semanticColors.colorCoding.lime.background.light]: semanticColors.colorCoding.lime.text.onLight,
    [semanticColors.colorCoding.lime.background.thin]: semanticColors.colorCoding.lime.text.onThin,

    [semanticColors.colorCoding.amber.background.bold]: semanticColors.colorCoding.amber.text.onBold,
    [semanticColors.colorCoding.amber.background.medium]: semanticColors.colorCoding.amber.text.onMedium,
    [semanticColors.colorCoding.amber.background.light]: semanticColors.colorCoding.amber.text.onLight,
    [semanticColors.colorCoding.amber.background.thin]: semanticColors.colorCoding.amber.text.onThin,

    [semanticColors.colorCoding.orange.background.bold]: semanticColors.colorCoding.orange.text.onBold,
    [semanticColors.colorCoding.orange.background.medium]: semanticColors.colorCoding.orange.text.onMedium,
    [semanticColors.colorCoding.orange.background.light]: semanticColors.colorCoding.orange.text.onLight,
    [semanticColors.colorCoding.orange.background.thin]: semanticColors.colorCoding.orange.text.onThin,

    [semanticColors.colorCoding.red.background.bold]: semanticColors.colorCoding.red.text.onBold,
    [semanticColors.colorCoding.red.background.medium]: semanticColors.colorCoding.red.text.onMedium,
    [semanticColors.colorCoding.red.background.light]: semanticColors.colorCoding.red.text.onLight,
    [semanticColors.colorCoding.red.background.thin]: semanticColors.colorCoding.red.text.onThin,

    [semanticColors.colorCoding.pink.background.bold]: semanticColors.colorCoding.pink.text.onBold,
    [semanticColors.colorCoding.pink.background.medium]: semanticColors.colorCoding.pink.text.onMedium,
    [semanticColors.colorCoding.pink.background.light]: semanticColors.colorCoding.pink.text.onLight,
    [semanticColors.colorCoding.pink.background.thin]: semanticColors.colorCoding.pink.text.onThin,

    [semanticColors.colorCoding.purple.background.bold]: semanticColors.colorCoding.purple.text.onBold,
    [semanticColors.colorCoding.purple.background.medium]: semanticColors.colorCoding.purple.text.onMedium,
    [semanticColors.colorCoding.purple.background.light]: semanticColors.colorCoding.purple.text.onLight,
    [semanticColors.colorCoding.purple.background.thin]: semanticColors.colorCoding.purple.text.onThin,
};

export const defaultHexColors: string[] = [...boldColors, ...mediumColors, ...lightColors, ...thinColors];

export const whiteHexColor = "#FFFFFF";
